<template>
  <div class="red-text" v-show="text">{{text}}</div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
div {
  width: 100%;
  text-align: center;
  font-size: 1rem;
  margin-bottom: 1.25rem;
}
</style>